<dx-data-grid [dataSource]="dataSource" [hoverStateEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true"
  [allowColumnResizing]="true" [columnResizingMode]="'nextColumn'" [showRowLines]="true" [showBorders]="true"
  [masterDetail]="{ enabled: true, template: 'rowMasterDetailTemplate' }"
  (onEditorPreparing)="onEditorPreparing($event)" (onToolbarPreparing)="onToolbarPreparing($event)"
  (onInitNewRow)="onInitNewRow($event)">

  <dxo-search-panel placeholder="Suche..." [width]="300" [visible]="true"></dxo-search-panel>

  <dxo-paging [pageSize]="5"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20, 50]" [showInfo]="true"
    infoText="Seite {0} von {1} Seiten ({2} Datensätze)" [showNavigationButtons]="true">
  </dxo-pager>

  <dxo-remote-operations [filtering]="true" [sorting]="true" [paging]="true">
  </dxo-remote-operations>

  <dxo-editing mode="form" [allowUpdating]="!disabled" [allowDeleting]="false" [allowAdding]="!disabled" [useIcons]="true">
    <dxo-form [colCount]="1" [labelLocation]="'top'">
      <dxi-item itemType="group">
        <dxi-item dataField="owi104" editorType="dxCheckBox" [label]="{ visible: false }"
          [editorOptions]="{ text: 'OWI 104'}" [visible]="entityArt === 1">
        </dxi-item>
        <dxi-item dataField="betreff">
          <dxi-validation-rule type="required" reevaluate="true"
            message="'Betreff' wird benötigt!"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="text" editorType="dxTextArea"></dxi-item>
      </dxi-item>
    </dxo-form>
  </dxo-editing>

  <dxi-column dataType="date" format="dd.MM.yyyy" dataField="erstellt"></dxi-column>
  <dxi-column dataField="betreff"></dxi-column>
  <dxi-column [visible]="false" dataField="text" editorType="dxTextArea"></dxi-column>
  <dxi-column dataField="benutzerName" caption="Erstellt durch"></dxi-column>
  <dxi-column dataField="owi104" dataType="boolean" caption="OWI 104" width="70px"
    [visible]="entityArt === 1"></dxi-column>

  <div *dxTemplate="let bemerkung of 'rowMasterDetailTemplate'">
    <span *ngIf="!bemerkung.data.text || !bemerkung.data.text.length" class="text-danger">Keine Daten</span>
    <div *ngIf="bemerkung.data.text && bemerkung.data.text.length">
      <div class="row">
        <button class="btn btn-success btn-sm pull-right" type="button" (click)="onClickPrint(bemerkung.data)"
          style="margin-left:5px"><span class="glyphicon glyphicon-print"></span> Drucken</button>
      </div>
      <div class="row" style="margin-top:10px">
        <dx-text-area [readOnly]="true" [(value)]="bemerkung.data.text">
        </dx-text-area>
      </div>
    </div>
    <!--<pre *ngIf="bemerkung.data.text && bemerkung.data.text.length" [innerHTML]="getText(bemerkung.data.text)"></pre>-->
  </div>
</dx-data-grid>